import React from 'react';
import {onFinishPallet, operatorExists, printManifest} from "./PalletBuilderController";
import Button from "@material-ui/core/Button";
import {useForm, Controller} from "react-hook-form";
import PressPalletIcon from "../PressPalletIcon";
import CheckedInOperatorText from "../../checkin3/CheckedInOperatorText";
import * as yup from "yup";
import {yupResolver} from '@hookform/resolvers';
import MuiAlert from '@material-ui/lab/Alert';
import BaseAdHocPage from "../../../framework/util/uicomps/BaseAdHocPage";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import StationChooserForSite from "../../stations/StationChooserForSite";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";

const LAST_STATION_KEY = "FinishPalletLastStationId";

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const validationStartBuilding = yup.object({
    unloadOperatorId: yup.string().required().test('unloadOperatorId', 'Operator id does not exist', operatorExists),
});

/**
 *
 * @param pallet If pallet is set, but not pallet id, this is a pallet checking out
 * @param palletId If pallet id is set, but not pallet, this is a reprint
 * @param onSaved
 * @param onCancelled
 * @param onRefresh
 * @param props
 * @returns {*}
 * @constructor
 */
const BuildPalletUIFinishPallet = ({currentState, sendEvent}) => {

    const pallet = currentState.context.pallet;

    const {register, handleSubmit, errors, setValue, control, watch} = useForm({
        resolver: yupResolver(validationStartBuilding)
    });


    if (!pallet)
        throw 'No pallet';

    const printNow = watch('printNow');

    const onSubmit = data => {
        localStorage.setItem(LAST_STATION_KEY, data.stationId);
        if (printNow)
            sendEvent("PRINTNOW", data);
        else
            sendEvent("PRINTLATER", data);

    };

    const contentItems = [];

    contentItems.push((
        <CheckedInOperatorText inputRef={register} useReactHookForms={true}
                               name={'unloadOperatorId'} autofocus={true}
                               error={errors.unloadOperatorId ? true : false}
                               errorMessage={errors.unloadOperatorId?.message}
                               fullWidth={true}
        />
    ));

    contentItems.push(
        (
            <FormControlLabel
                control={<Checkbox inputRef={register} name="printNow"/>}
                label="Print Manifest Now?"
            />

        ));

    printNow && contentItems.push(
        (
            <StationChooserForSite label='Print Manifest On' fullWidth={true} name="stationId" size="small" variant="outlined" control={control} errors={errors} register={register}/>
        )
    );

    printNow && contentItems.push(
        (
            <FormControlLabel
                control={<Checkbox inputRef={register} name="saveDesignerData"/>}
                label="Download Designer Data"
            />

        ));

    const buttonItems = [];
    buttonItems.push((
        <Button type="submit" variant="contained" color="primary" fullWidth={true}>
            Finish And Print Manifest {printNow ? 'Now' : 'Later'}
        </Button>));
    buttonItems.push((
        <Button variant="outlined" onClick={()=>sendEvent("CANCEL")} fullWidth={true} >
            Cancel And Keep Building
        </Button>));

    const title = 'Unload' + ' Pallet';
    const description = 'Unload pallet and print manifest';

    const submitForm = (
        <form onSubmit={handleSubmit(onSubmit)}>
            <BaseAdHocPage icon={<PressPalletIcon/>} title={title}
                           description={description} buttons={buttonItems}
                           content={contentItems}/>

        </form>

    );


    const PageInGrid = (

        <Grid container
              direction="row"
              justify="center"
              alignItems="center"
        >
            <Grid item xs={2}>
            </Grid>
            <Grid item xs={8}>
                {submitForm}
            </Grid>
            <Grid item xs={2}>
            </Grid>
        </Grid>

    );


    return PageInGrid;



}
export default BuildPalletUIFinishPallet;